export const hasProductNewSeoBehavior = (url: string) => {
    return [
        '/defumoxan-1-5mg-tbl-nob-100',
        '/samahan-bylinny-napoj-25-sacku',
        '/biosil-plus-tbl-60',
        '/tebokan-120mg-por-tbl-flm-30x120mg',
        '/oscillococcinum-por-gra-30x1gm',
        '/neospan-forte-swiss-45-tobolek',
        '/kaloba-por-gtt-sol-1x50ml',
        '/blokurima-long-sacky-30x4g',
        '/hylak-forte-por-sol-100ml',
        '/tussirex-sirup-120ml',
        '/aescin-teva-por-tbl-ent-90x20mg',
        '/iberogast-por-gtt-sol-50ml',
        '/diozen-500mg-tbl-flm-120',
        '/ive-inkontinstop-tob',
        '/stopkasel-medical-sirup-dr-weiss-200-100ml-navic',
        '/fytofem-harmony-control-tbl-90',
        '/soledum-200mg-enterosolventni-mekke-tobolky',
        '/bac-entos-oralni-probiotikum-30-tablet',
        '/phyteneo-kolodium-forte-10-ml',
        '/smecta-3g-por-plv-sus-10',
        '/ichtoxyl-ung-1x30g',
        '/enterol-por-cps-dur-10x250mg',
        '/sinupret-por-gtt-sol-1x100ml',
        '/stopangin-spr-1x30ml',
        '/beastpink-spalovac-tuku-night-burn-120-kaps-ano-ne-ne-ne-smes-kapslovy',
        '/betadine-ung-1x20g-h',
        '/essentiale-por-cps-dur-100',
        '/erdomed-por-plv-sol-20x225mg',
        '/neurobion-100mg-50mg-1mg-tbl-flm-30',
        '/rowatinex-cps-20-blistr',
        '/enzycol-dna-tob-100-40',
        '/canephron-tbl-obd-60',
        '/canesten-gyn-1-den-vag-tbl-1x500mg',
        '/faktu-rct-supp-20-1444640363',
        '/calcichew-d3-ctb-20',
        '/espumisan-kapky-100mg-ml-por-gtt-eml-1x50ml',
        '/supradyn-co-q10-energy-tbl-60-1513262380',
        '/lactulosa-biomedica-por-sir-1x500ml-50',
        '/sinupret-50-tablet',
        '/navlasil-serum-na-vlasy-50ml',
        '/coldrex-horky-napoj-citron-med-10-ks',
        '/hekla-lava-ch9-gra-4g',
        '/pssst-forte-ustni-sprej-proti-chrapani-15ml-10ml',
        '/jox-spr-1x30ml',
        '/corsodyl-ustni-voda-0-1-200ml',
        '/biogaia-protectis-kapky-10ml-tuba',
        '/vitango-200mg-tbl-flm-30x200mg',
        '/zinkorot-25mg-tbl-nob-50x25mg',
        '/babycalm-doplnek-stravy-15ml-koncentratu',
        '/hemostop-gel-da-vinci-academia-75-ml',
        '/persen-forte-cps-20',
        '/faktu-50mg-g-10mg-g-rct-ung-20g',
        '/exoderil-sol-1x20ml-200mg',
        '/drosetux-neo-sir-1x150ml',
        '/dexoket-25mg-tbl-flm-10x25mg-ii',
        '/wobenzym-drg-800',
        '/akneroxid-10-gel-1x50g-10',
        '/lioton-100-000-gel-drm-gel-1x100g',
        '/daosin-tablety-tbl-30',
        '/helicid-10-zentiva-cps-etd-28x10mg',
        '/coriolus-90cps',
        '/jox-sol-1x100ml',
        '/rosalgin-easy-140mg-vag-sol-5x140ml',
        '/plantur21-longhair-nutri-kofeinovy-sampon-200ml',
        '/equazen-tob-180',
        '/hairburst-ampon-pro-del-siln-j-vlasy-350ml',
        '/traumaplant-ung-1x100g',
        '/cetalgen-500mg-200mg-tbl-flm-20-ii',
        '/nizoral-expert-sampon-200ml',
        '/procto-glyvenol-rct-crm-1x30g',
        '/anti-ethanol-07-ae-07-5x2kapsle',
        '/imunoglukan-p4h-acute-cps-5x300mg',
        '/levopront-kapky-por-gtt-sol-1x15ml-ii',
        '/preventan-akut-tbl-30',
        '/feminus-doplnek-stravy-60-tablet',
        '/orofar-1mg-1mg-pas-24',
        '/hemagel-procto-cipky-10ks-1468398392',
        '/globifer-forte-40-tablet',
        '/caltrate-plus-por-tbl-flm-90',
        '/dolgit-crm-1x100g-5g',
        '/vagisan-hydrokrem-25g',
        '/ascorutin-tbl-obd-50',
        '/tribulus-terrestris-120-tbl-gymbeam-unflavored-120-tab',
        '/hedelix-sirup-por-sol-1x100ml-2g-kwm',
        '/gynocaps-vaginalni-tobolky-14ks',
        '/blokurima-uro-2g-d-manozy-30-sacku',
        '/hemagel-5g-1464853057',
        '/acc-20mg-ml-sir-1x100ml',
        '/valetol-por-tbl-nob-24',
        '/pirabene-1200mg-por-tbl-flm-60x1200mg',
        '/toothbrush-bila',
        '/namman-muay-thajsky-krem-100g',
        '/clerex-475mg-10-tobolek-pro-muze',
        '/enditril-100mg-cps-dur-10',
        '/hbf-detsky-emulgel-proti-nadymani-pupik-100ml',
        '/swiss-naturevia-ostropestrec-forte-cps-60',
        '/hubnuti-bylinne-kapky-dr-popov-50ml',
        '/clerex-475mg-10-tobolek-pro-zeny',
        '/gs-mamatest-10-tehotensky-test-2ks-cr-sk',
        '/devenal-500mg-tbl-flm-60',
        '/loperon-cps-por-cps-dur-20x2mg',
        '/radepur-baby-150ml',
        '/aulin-gel-drm-gel-1x100g-3g',
        '/levopront-sirup-por-sir-1x120ml',
        '/palsar7-osetrujici-led-maska-na-oblicej-a-krk-zlata',
        '/grep-extrakt-z-jader-grepavit-25ml-dr-popov',
        '/engystol-tbl-50',
        '/mollers-omega-3-muj-prvni-rybi-olej-250ml',
        '/excilor-proti-plisni-nehtu-3-3ml',
        '/ricinus-communis-ch5-gra-4g',
        '/elmex-gelee-stm-gel-1x25mg',
        '/piracetam-al-1200-por-tbl-flm-120x1200mg',
        '/imazol-krempasta-10mg-g-drm-pst-30g',
        '/donnahair-forte-4mesicni-kura-tob-90-30-zdarma',
        '/protifar-por-plv-sol-1x225g',
        '/nicorette-spray-1mg-davka-orm-spr-1x13-2ml-150mg',
        '/sedatif-pc-tbl-slg-90',
        '/walmark-uroval-manosa-akut-tbl-20',
        '/imudon-neo-tabl-rozp-v-ustech-se-sladidly-tbl-40',
        '/antimetil-tbl-30',
        '/infadolan-drm-ung-1x100gm-laminatova-tuba',
        '/coldrex-maxgrip-citron-10-ks',
        '/erdoherbal-medovy-sirup-140ml',
        '/acc-long-tbl-eff-20x600mg',
        '/karpal-akut-50ml',
        '/sinupret-forte-por-tbl-obd-20',
        '/imunoglukan-p4h-sirup-250-ml',
        '/magnesii-lactici-0-5-tbl-mvm-por-tbl-nob-100x0-5g',
        '/procto-glyvenol-rct-supp-10',
        '/cannamediq-hypertezin-60tob',
        '/tyndaflor-vaginalni-cipky-10x2g',
        '/astina-kilostop-cps-60',
        '/garsin-60-cps-hubnuti',
        '/gynex-bylinny-koncentrat-30-ml',
        '/rhino-horn-konvicka-na-vyplach-nosu-cervena-1495546025',
        '/swiss-naturevia-imunohelp-cps-60',
        '/bi-oil-200ml',
        '/endwarts-extra-kryoterapie-fibromu-14-3g',
        '/ataralgin-50-tablet',
        '/isochol-drg-30x400mg-lahv',
        '/stopvirus-medical-sirup-dr-weiss-200-100ml-navic',
        '/topvet-lichorerisnice-extrakt',
        '/vigantolvit-d3-2000-i-u-60-tobolek',
        '/emoxen-100mg-g-gel-duopack-2-x-100-g',
        '/vitella-ictamo-ung-30g',
        '/tasectan-duo-500mg-tbl-12',
        '/altermed-dubova-kura-gel-50g',
        '/Coryzalia-tbl-obd-40',
        '/diamizin-gurmar-150-kapsli',
        '/gurmar-50-kapsli',
        '/stoptussin-por-gtt-sol-1x50ml-pip',
        '/penoxal-50-mg-30-kapsli-1473772880',
        '/gyntima-vaginalni-cipky-probiotica-forte-10-ks',
        '/kaloba-por-tbl-flm-21x20mg',
        '/cemio-red3-cps-90',
        '/chytra-houba-pythie-biodeur-nail-3x3g',
        '/excipial-u-lipolotio-40mg-ml-drm-eml-200ml',
        '/bio-mesickova-zinkova-mast-70-ml',
        '/allnature-draci-krev-30ml',
        '/escapelle-por-tbl-nob-1x1-5mg',
        '/postinor-2-por-tbl-nob-2x0-75mg',
        '/sedalia-sirup-por-sir-1x200ml',
        '/aviril-detsky-olej-s-azulenem-50-ml',
        '/phyteneo-neocide-gel-0-1-octenidine-50ml',
        '/allnature-rozchodnice-ruzova-500mg-60-kapsli',
        '/driclor-roztok-20ml-roll-on',
        '/ladylab-night-burner-60-tablet',
        '/imodium-2mg-cps-dur-20',
        '/herbadent-masazni-roztok-gng-sol-1x25ml',
        '/walmark-prostenal-control-tbl-90-bls',
        '/voltaren-forte-20mg-g-gel-iib-cz-180-g',
        '/synefrin-90-tab-gym-beam-unflavored',
        '/silicolgel-200-ml',
        '/erectan-400mg-20-tobolek-1376056663',
        '/laxygal-por-gtt-sol-1x25ml',
        '/sorted-skin-denni-tonovaci-krem-proti-zarudnuti-5v1-5-in-i-anti-redness-day-cream-spf-50-30-ml',
        '/homeogene-9-tbl-60',
        '/espumisan-por-cps-mol-100x40mg',
        '/veroval-crp-domaci-test',
        '/corsodyl-1-gel-stm-gel-1x50g-1526290424',
        '/desodrop-ocni-roztok-8ml',
        '/inofolic-60-sacku',
        '/tantum-verde-spray-forte-orm-spr-15ml-0-30',
        '/minorga-50mg-ml-drm-sol-3x60ml',
        '/gastrotuss-baby-sirup-200ml',
        '/tebokan-40mg-por-tbl-flm-100x40mg',
        '/nux-vomica-ch9-gra-4g',
        '/traumeel-tbl-50',
        '/nolpaza-20mg-por-tbl-ent-14x20mg',
        '/desloratadin-xantis-5mg-tbl-nob-30',
        '/pangamin-se-sladovym-extr-vitalita-200tbl-sacek',
        '/remyelin-uridine-pea-vitaminy-b-a-c-30-kapsul',
        '/akneroxid-5-gel-1x50g-5',
        '/endwarts-freeze-7-5g-kryoterapie-bradavic',
        '/thuya-occidentalis-ch9-gra-4g',
        '/revitalon-forte-cps-90-30-zdarma',
        '/tasectan-500-mg-15tobolek',
        '/mycobaby-sirup',
        '/collalloc-100-bioaktivni-morsky-kolagen-30x3-3g',
        '/skinoren-krem-drm-crm-1x30gm-20',
        '/lunestil-15-duokapsli',
        '/tussirex-nocni-sirup-120ml',
        '/butyrate-infusion-cps-30',
        '/fytofontana-citrovital-kapky-25ml',
        '/acutil-cps-60',
        '/mastodynon-gtt-1x50ml',
        '/walmark-biopron-baby-kapky-10ml',
        '/zovirax-duo-50mg-g-10mg-g-krem-drm-crm-1x2g-1488369437',
        '/alori-odstranovac-plisni-s-dlouhodobym-ucinkem-250ml',
        '/canyon-chytry-naramek-pro-seniory-s-funkci-sos-telefonu-sledovani-polohy-gps-lbs-wi-fi-hands-free-cne-st01bb',
        '/stoptussin-sirup-por-sir-1x180ml-pip',
        '/myo-inositol-folic-acid-120g-myo-inositol-s-kyselinou-listovou',
        '/zodac-10mg-tbl-flm-40',
        '/weleda-skin-food-75-ml',
        '/silymarin-140-generica-cps-90',
        '/gynimun-intim-care-vaginalni-kapsle-10ks',
        '/agnucaston-por-tbl-flm-30',
        '/swiss-naturevia-perfectday-cps-60',
        '/rakytnicek-mutlivitamin-zelatinky-s-rakytnik-70ks',
        '/woman-secret-girl-or-boy-test-na-urceni-pohlavi-ditete',
        '/diclofenac-al-25mg-tbl-ent-50',
        '/maxxwin-nmn-500-forte-60-kapsli',
        '/contractubex-drm-gel-1x20g',
        '/novo-passit-sol-1x100ml',
        '/enzymax-r-120-cps-bls-cze-slo',
        '/lactil-56-tobolek-1',
        '/nurofen-pro-deti-jahoda-20mg-ml-por-sus-100ml-ii',
        '/reishi-90cps-ext-vg',
        '/havlikuv-prirodni-zazrak-50ml-vsestranna-mast',
        '/glukanek-sirup-pro-deti-150ml',
        '/famosan-10mg-por-tbl-flm-10x10mg',
        '/ginkgo-biloba-40mg-tbl-90-90-bio-pharma',
        '/kardi-ai-kardi-ai-trimesicni-dlouhodoby-ekg-monitoring-srdce-xxxl',
        '/lapis-tycinka-na-bradavice',
        '/cicatridina-posevni-cipky-10x2g',
        '/rennie-por-tbl-mnd',
        '/sinecod-1-5-mg-sirup-300-mg-200-ml',
        '/gaviscon-duo-efekt-zvykaci-tablety-tbl-mnd-24',
        '/unilakt-se-skorici-tbl-850',
        '/nalgesin-s-por-tbl-flm-40x275mg',
        '/walmark-degasin-280mg-tob-32-bls',
        '/matchatea-jemne-mlety-zeleny-caj-sacky-30x2g',
        '/rymastop-dr-weiss-bylinny-nosni-spray-30ml',
        '/geratam-1200-tbl-obd-100x1200mg',
        '/centrum-pro-zeny-tbl-60',
        '/stopkasel-angin-ex-dr-weiss-30-ml',
        '/venira-pece-o-vlasy-nehty-a-plet-cps-80',
        '/psyllium-probio-kapsle-110-ks-10-ks',
        '/febichol-por-cps-mol-50x100mg',
        '/biohar-vlasovy-aktivator-75ml',
        '/proenzi-3-tbl-180',
        '/exoderil-crm-1x30g',
        '/kendamil-kojenecke-pocatecni-mleko-1-900g-new',
        '/canesten-krem-crm-1x20g-200mg',
        '/movit-mega-detox-ostropestrec-kurkumin-forte-60-kapsli',
        '/navela-1-5mg-tbl-nob-1',
        '/almiral-gel-1x100g',
        '/wartner-pero-na-odstraneni-bradavic',
        '/kaloba-20mg-7-5ml-sirup-sir-1x100ml',
        '/proerecta-klasik-12-tablet',
        '/sudocrem-multi-expert-400g',
        '/lavekan-80mg-cps-mol-28',
        '/proerecta-shot-8ks',
        '/arginmax-forte-pro-zeny-tob',
        '/remescar-vacky-a-kruhy-pod-ocima-8ml',
        '/water-fighter',
        '/gynella-silver-caps-10-vaginalnich-tobolek',
        '/biopron-forte-30-tob',
        '/kinedryl-tbl-10',
        '/belici-pasta-opalescence-133-g',
        '/kneipp-odvodneni-sumive-tablety-20-tablet',
        '/sunar-gravimilk-s-prichuti-vanilka-450g-1',
        '/woolite-mix-colors-3-6-l-60-pracich-davek',
        '/calcichew-d3-ctb-60',
        '/femibion-3-kojeni-tbl-28-tob-28',
        '/aurisclean-usni-sprej-davinci-academia-15ml',
        '/bercoff-fat-burner-l-carnitine-30g',
        '/paragrippe-tbl-60',
        '/nurofen-rapid-400mg-cps-mol-20-i-1',
        '/bioalis-kozi-kolostrum-180-tob',
        '/afrodiziakalni-kapky-spanish-fly-drops-30ml',
        '/plantur39-fyto-kofeinovy-sampon-jemne-vlasy-250ml',
        '/vaxol-usni-spray-10ml',
        '/psyllium-fit-slim-cps-180-topnatur-148g',
        '/gs-mamavit-tbl-90-cr-sk',
        '/xyzal-por-tbl-flm-14x5mg',
        '/elli-menoosteo-forte-tob-90-30zdarma',
        '/prospan-sirup-200-ml',
        '/tehotensky-test-clearblue-dig-indik-terminu-poceti',
        '/detoxikacni-naplasti-20-ks',
        '/astaxanthin',
        '/sinupret-gtt-1x50ml',
        '/gf-quercetin-95-90cps',
        '/femannose-p-produo-20-s-k',
        '/neo-angin-bez-cukru-tbl-24',
        '/nestle-beba-comfort-1-hmo-800g',
        '/fertility-blend-pro-zeny-tob-90',
        '/hyiodine-1x50ml',
        '/veroval-chlamydie-domaci-test',
        '/diovarix-plus-tbl-180',
    ].includes(url)
}
